// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface ChildIconSignature {
  Element: SVGSVGElement;
}

export const ChildIcon: TOC<ChildIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M13.754 15.423C14.506 14.877 15 13.998 15 13C15 11.346 13.654 10 12 10C10.346 10 9 11.346 9 13C9 13.998 9.494 14.877 10.246 15.423C8.922 16.075 8 17.427 8 19V20C8 20.553 8.447 21 9 21H15C15.553 21 16 20.553 16 20V19C16 17.427 15.079 16.075 13.754 15.423ZM12 12C12.551 12 13 12.449 13 13C13 13.551 12.551 14 12 14C11.449 14 11 13.551 11 13C11 12.449 11.45 12 12 12ZM12 17C10.896 17 10 17.896 10 19H14C14 17.896 13.104 17 12 17Z"/>
</svg>
</template>;